import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#1976D2" }, // Blue
    secondary: { main: "#FF4081" }, // Pink
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

export default theme;
